(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var VARIANTS = ['falcon-scroll-reveal--rise', 'falcon-scroll-reveal--rise-scale', 'falcon-scroll-reveal--fade', 'falcon-scroll-reveal--side'];
  var LIGHT_VARIANTS = ['falcon-scroll-reveal--rise', 'falcon-scroll-reveal--fade'];

  var observer;
  var boundEls = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var variantIndex = 0;

  function ensureObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-revealed', entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -5% 0px' }
    );
    return observer;
  }

  function hasVisibleBox(el) {
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function initFalconScrollReveal() {
    var candidates = document.querySelectorAll(
      '#MainContent > .shopify-section > *:not(style):not(script):not(.falcon-qv-modal):not(.falcon-scroll-reveal)'
    );
    if (!candidates.length) return;

    var obs = ensureObserver();

    candidates.forEach(function (el) {
      if (boundEls) {
        if (boundEls.has(el)) return;
        boundEls.add(el);
      } else if (el.dataset.falconRevealBound) {
        return;
      } else {
        el.dataset.falconRevealBound = 'true';
      }

      // If an element has no measurable box (display:contents, a custom
      // element that hasn't hydrated yet, etc.) we cannot reliably observe
      // it — leave it alone rather than risk hiding it forever.
      if (!hasVisibleBox(el)) return;

      var rectForSize = el.getBoundingClientRect();
      // These product sections can be several times taller than the
      // viewport. Scaling something that large still repaints a huge area
      // every frame, so keep the heavier "scale" variant for normal-sized
      // blocks only and fall back to a cheap fade/rise for giant ones.
      var isOversized = rectForSize.height > window.innerHeight * 1.4;
      var pool = isOversized ? LIGHT_VARIANTS : VARIANTS;

      el.classList.add('falcon-scroll-reveal', pool[variantIndex % pool.length]);
      variantIndex++;

      // Anything already on screen at load time shows immediately, no
      // animation delay — only content below the fold gets the reveal.
      var rect = el.getBoundingClientRect();
      var alreadyInViewport = rect.top < window.innerHeight && rect.bottom > 0;
      if (alreadyInViewport) {
        el.classList.add('is-revealed');
      }

      obs.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFalconScrollReveal);
  } else {
    initFalconScrollReveal();
  }


  window.addEventListener('load', initFalconScrollReveal);
  document.addEventListener('shopify:section:load', initFalconScrollReveal);


  function initFalconScrollIndicator() {
    var indicator = document.getElementById('falcon-scroll-indicator');
    if (!indicator) return;

    var ticking = false;

    function update() {
      ticking = false;

      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;

      if (scrollableHeight <= 0) {
        indicator.classList.remove('is-visible');
        return;
      }

      var progress = Math.min(Math.max(scrollTop / scrollableHeight, 0), 1);
      var margin = 12;
      var trackHeight = window.innerHeight - indicator.offsetHeight - margin * 2;
      var top = margin + progress * trackHeight;

      indicator.style.top = top + 'px';
      indicator.classList.add('is-visible');
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  initFalconScrollIndicator();
})();
